import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const fetchTrialPhotoTypes = async ({ trialId, patientId }) => {
  const token = localStorage.getItem("token");

  const response = await axios.get(`${__API_URL__}/api/photos/photo_types_dropdown/`, {
    params: {
      trial: trialId ?? "",
      patient: patientId,
    },
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return response.data;
};

const useGetTrialPhotoTypes = ({ trialId, patientId, enabled = true }) => {
  return useQuery({
    queryKey: ["trial_photo_types", trialId, patientId],
    queryFn: () => fetchTrialPhotoTypes({ trialId, patientId }),
    enabled: enabled && Boolean(patientId),
  });
};

export default useGetTrialPhotoTypes;
